export const gaPageView = (t = 0) => {
  return new Promise((resolve, reject) => {
    let location = window.location.pathname + window.location.search
    if (typeof window.ga === 'function') {
      setTimeout(() => {
        window.ga('send', {
          hitType: 'pageview',
          page: location
        })
        resolve('gaPageView sent')
      }, t)
    } else {
      reject('gaPageView is not a function')
    }
  })
}

export const gaDataLayer = (event, t = 0) => {
  return new Promise((resolve, reject) => {
    window.dataLayer = window.dataLayer || []
    // if (typeof window.gaDataLayer === 'function') {
      setTimeout(() => {
        window.dataLayer.push(event)
        resolve('gaDataLayer pushed')
      }, t)
    // } else {
    //   reject('gaDataLayer is not a function')
    // }
  })
}



// WEBPACK FOOTER //
// ./src/analytics.js